import React, {Component} from 'react';

import Popup from '../Popup/index';

import Registry from '../../../registry/index';
import AnonymousLoginPopup from "../AnonymousLoginPopup";

class RoomCreatePopup extends Popup {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.doCreateRoom = this.doCreateRoom.bind(this);
        this._getRoomListError = this._getRoomListError.bind(this);
        this._onRoomCreateSuccess = this._onRoomCreateSuccess.bind(this);
        this._onRoomCreateFail = this._onRoomCreateFail.bind(this);

        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    componentDidMount() {
        super.componentDidMount();

        let {currentUser} = this.props;

        this.setState({
            ...super.state,
            pending: false,
            disabled: currentUser.isAnonymous(),
            closedRoom: false,
            error: ''
        });
    }

    componentWillReceiveProps(nextProps) {
        let {currentUser} = nextProps;

        this.setState({disabled: currentUser.isAnonymous()});
    }

    _afterClose() {
        super._afterClose();

        this.setState({
            name: '',
            closedRoom: false,
            password: '',
            error: '',
            pending: false
        });
    }

    onSubmit(event) {
        event.preventDefault();

        if (!this.state.name) {
            this.setState({error: 'name_empty'});
            return false;
        }

        if (this.state.closedRoom) {
            if (!this.state.password) {
                this.setState({error: 'password_empty'});
                return false;
            }
        }

        this.setState({
            pending: true,
            error: ''
        });

        Registry.get('chatInterface').getRoomList(this.doCreateRoom, this._getRoomListError)
    }

    doCreateRoom(List) {
        for (var index in List) {
            var existingRoom = List[index];
            if (existingRoom.roomId == this.state.name) {
                this.setState({
                    error: 'room_exists',
                    pending: false
                });
                return false;
            }
        }

        Registry.get('chatInterface').createVirtualRoom(
            this.state.name,
            this.state.password,
            this._onRoomCreateSuccess,
            this._onRoomCreateFail
        );
    }

    _getRoomListError() {
        console.log("RoomCreatePopup._getRoomListError");

        this.setState({
            error: 'general',
            pending: false
        });
    }

    _onRoomCreateSuccess() {
        console.log("RoomCreatePopup._onRoomCreateSuccess");

        this.close();
    }

    _onRoomCreateFail(Code, Reason) {
        console.log("RoomCreatePopup._onRoomCreateFail");

        this.setState({
            pending: false,
            error: 'general'
        });
    }

    onClickAnonymous(event) {
        event.preventDefault();
        AnonymousLoginPopup.open();
    }

    render() {
        let lang = Registry.get('locale');

        let {currentUser} = this.props;

        let {name, password, pending, disabled, closedRoom, error} = this.state;

        let className = 'popup popup-new-room ' + this.state.visibility;

        let nameErrorBlock;
        switch (error) {
            case 'general':
                nameErrorBlock = <p className="error general">{lang.create_room_error_general}</p>; break;
            case 'xxl':
                nameErrorBlock = <p className="error xxl" dangerouslySetInnerHTML={{__html: lang.create_room_error_xxl}}></p>; break;
            case 'name_empty':
                nameErrorBlock = <p className="error name_empty">{lang.create_room_error_name_empty}</p>; break;
            case 'room_exists':
                nameErrorBlock = <p className="error room_exists">{lang.create_room_error_room_exists}</p>; break;
        }

        let formProps = !currentUser.isAnonymous() ? {onSubmit: this.onSubmit} : {onClick: this.onClickAnonymous};

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="top">
                    <p>{lang.create_new_room}</p>
                    <div className="close" onClick={() => this.close()}/>
                </div>
                <div className="content">
                    <form action="#" {...formProps}>
                        {nameErrorBlock}

                        <input
                            name="name"
                            type="text"
                            placeholder={lang.room_name}
                            onChange={(event) => this.setState({name: event.target.value})}
                            value={name}
                            readOnly={pending && 'readonly'}
                            disabled={disabled && 'disabled'}
                            maxLength="40"
                        />

                        <input
                            name="closed"
                            type="checkbox"
                            id="input_new_room_closed"
                            onChange={(event) => this.setState({closedRoom: event.target.checked})}
                            checked={closedRoom && 'checked'}
                            disabled={disabled && 'disabled'}
                        />

                        <label htmlFor="input_new_room_closed">{lang.with_password}</label>
    
                        {error === 'password_empty' && <p className="error password_empty">{lang.create_room_error_password_empty}</p>}

                        <input
                            name="password"
                            type="text"
                            className="color-password"
                            placeholder={lang.your_password}
                            autoComplete="off"
                            onChange={(event) => this.setState({password: event.target.value})}
                            value={password}
                            readOnly={pending && 'readonly'}
                            disabled={(!closedRoom || disabled) && 'disabled'}
                        />
    
                        {pending && <p className="please_wait">{lang.please_wait}</p>}
    
                        <input type="submit" value={lang.create} disabled={(pending || disabled) && 'disabled'}/>
                    </form>
                </div>
            </div>
        )   
    } 
}

RoomCreatePopup.generateKey = function(props) { return 'create-room-popup' };
RoomCreatePopup.mount = function(props, onMount) { return Popup.mount(RoomCreatePopup, props, onMount) };
RoomCreatePopup.open = function(props) {
    var id = RoomCreatePopup.generateKey(props);

    if (!Popup.popups[id]) {
        RoomCreatePopup.mount(props, (r) =>  Popup.popups[id].open())
    } else {
        Popup.popups[id].open()
    }
};

export default RoomCreatePopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomCreatePopup/index.js